import PropTypes from 'prop-types';

const DeviceMessageSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.3359 20.3334V23.1667C33.3359 28.4167 30.3359 30.6667 25.8359 30.6667H10.8359C6.33594 30.6667 3.33594 28.4167 3.33594 23.1667V14.1667C3.33594 8.91669 6.33594 6.66669 10.8359 6.66669H15.3359C15.1193 7.30002 15.0026 8.00002 15.0026 8.75002V15.2501C15.0026 16.8667 15.5359 18.2334 16.4859 19.1834C17.4359 20.1334 18.8026 20.6667 20.4193 20.6667V22.9833C20.4193 23.8333 21.3859 24.35 22.1026 23.8834L26.9193 20.6667H31.2526C32.0026 20.6667 32.7026 20.55 33.3359 20.3334Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M36.6667 8.74998V15.25C36.6667 17.7334 35.4 19.6 33.3333 20.3333C32.7 20.55 32 20.6667 31.25 20.6667H26.9167L22.1 23.8833C21.3833 24.35 20.4167 23.8333 20.4167 22.9833V20.6667C18.8 20.6667 17.4333 20.1333 16.4833 19.1833C15.5333 18.2333 15 16.8667 15 15.25V8.74998C15 7.99998 15.1167 7.29998 15.3333 6.66665C16.0667 4.59998 17.9333 3.33331 20.4167 3.33331H31.25C34.5 3.33331 36.6667 5.49998 36.6667 8.74998Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M24.3359 35.4166H19.5859V30.6667C19.5859 29.9834 19.0193 29.4167 18.3359 29.4167C17.6526 29.4167 17.0859 29.9834 17.0859 30.6667V35.4166H12.3359C11.6526 35.4166 11.0859 35.9833 11.0859 36.6666C11.0859 37.35 11.6526 37.9166 12.3359 37.9166H24.3359C25.0193 37.9166 25.5859 37.35 25.5859 36.6666C25.5859 35.9833 25.0193 35.4166 24.3359 35.4166Z"
        fill={color}
      />
      <path
        d="M25.7344 13.3333C25.0344 13.3333 24.4844 12.7666 24.4844 12.0833C24.4844 11.4 25.051 10.8333 25.7344 10.8333C26.4177 10.8333 26.9844 11.4 26.9844 12.0833C26.9844 12.7666 26.4177 13.3333 25.7344 13.3333Z"
        fill={color}
      />
      <path
        d="M30.4141 13.3333C29.7141 13.3333 29.1641 12.7666 29.1641 12.0833C29.1641 11.4 29.7307 10.8333 30.4141 10.8333C31.0974 10.8333 31.6641 11.4 31.6641 12.0833C31.6641 12.7666 31.0974 13.3333 30.4141 13.3333Z"
        fill={color}
      />
      <path
        d="M21.0312 13.3333C20.3313 13.3333 19.7812 12.7666 19.7812 12.0833C19.7812 11.4 20.3479 10.8333 21.0312 10.8333C21.7146 10.8333 22.2812 11.4 22.2812 12.0833C22.2812 12.7666 21.7312 13.3333 21.0312 13.3333Z"
        fill={color}
      />
    </svg>
  );
};

DeviceMessageSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default DeviceMessageSvg;
